import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function MegaConcert({}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Salut à Toi,</p>
      <p>Je viens d'apprendre via linkedin ta nomination temporaire, </p>
      <span>FELICITATIONS ! ! ! Pourvu que cela dure !!!</span>
      <p>
        J'ai un super plan à te proposer : tu sais que la{" "}
        <span>superbe ADELE </span>
        est en concert à Paris Bercy ce vendredi. On est déjà 4 à y aller et
        j'ai 2 places pour Toi et qui tu voudras en plus, mon frère a un copain
        qui peut nous avoir des badges pour le back-stage.
      </p>
      <p>
        Tu te rends compte, tu vas pouvoir aller dans les coulisses et
        rencontrer <span>ta star préférée</span>.
      </p>
      <p>
        Avant le spectacle, on se retrouve tous à notre ancien QG à 17 H. Ce
        sera l'occasion d'évoquer les bons vieux souvenirs et pour toi d'arroser
        ta géniale nomination.
      </p>
      <p>Et, en plus, je risque de devenir un de tes plus gros clients !</p>
      <p>
        Alors en attendant de te parler business, vendredi tu fermes la boutique
        en début d'après-midi et tu viens nous rejoindre.
      </p>
      <p>On compte sur toi pour la fête et la suite !</p>
      <p>Alex et toute la promo</p>
      <p className="underline">😄😄😄😄😄😄😄😄😄😄</p>
      <MailSignature
        emetteurLogo={MegaConcert.metadata.emetteurLogo}
        emetteur={MegaConcert.metadata.emetteur}
        emetteurPoste={MegaConcert.metadata.emetteurPoste}
        emetteurEntreprise={MegaConcert.metadata.emetteurEntreprise}
      />
    </div>
  );
}

MegaConcert.metadata = {
  titre: "MEGA CONCERT",
  cleMail: "mega_concert",
  messageTransfert: false,
  emetteur: "Alexandre Vrigny",
  emetteurPoste: "",
  emetteurEntreprise: "",
  emetteurLogo: null,
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default MegaConcert;
